import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { formatForApi } from '../utils/date.util';
import dayjs from '../utils/dayjs-config.util';


export class FormatDateForApiInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method === 'POST' || request.method === 'PUT') {
      this.formatDatesForApi(request.body);
    }
    return next.handle(request);
  }


  formatDatesForApi(body: any) {
    if (body === null || body === undefined) {
      return body;
    }
    if (typeof body !== 'object') {
      return body;
    }
    for (const key of Object.keys(body)) {
      const value = body[key];
      if ((value instanceof Date) && dayjs(value).isValid()) {
        body[key] = formatForApi(value);
      } else if ((value instanceof Date) && !dayjs(value).isValid()) {
        console.warn('Invalid date in request body!');
      } else if (typeof value === 'object') {
        this.formatDatesForApi(value);
      }
    }
  }
}
